import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'flux/utils';

import ListView from '../Common/ListView.react';
import CourseComplianceItem from './CourseComplianceItem';
import CourseActions from '../../actions/CourseActionCreator';
import CourseComplianceStore from '../../stores/CourseComplianceStore';
import ROLES from '../../constants/Roles';
import IconPerson from 'material-ui/svg-icons/action/perm-identity';

import buildContextMenu from '../Common/BuildContextMenu';

const getMenuItems = (id) => {
    return [
        {
            link: `/dashboard/user/${id}`,
            icon: <IconPerson />,
            label: 'User profile',
            condition: {
                roles: [ROLES.ADMIN]
            }
        },
    ];
};

class CourseComplianceByUser extends Component {

    componentDidMount() {
        CourseActions.getComplianceByUserId(this.state.userId);
    }

    render() {
        const actions = buildContextMenu((this.props.menuItems || getMenuItems(this.state.userId)), this.context.auth);
        return (
            <ListView
                title="Compliance"
                items={this.state.courses}
                itemDecorator={CourseComplianceItem}
                actions={actions}
                backButton={true}
            />
        );
    }

}

CourseComplianceByUser.getStores = () => ([CourseComplianceStore]);
CourseComplianceByUser.calculateState = (prevState, props) => {
    const userId = Number((!!props.routeParams && props.routeParams.id) || props.userId);
    return ({
        userId,
        courses:    (CourseComplianceStore.get(userId) || []),
    });
};

CourseComplianceByUser.contextTypes = {
    auth:   PropTypes.object.isRequired
};

export default Container.create(CourseComplianceByUser, {withProps: true});
